export function recommendationNotFoundEventHandler(source: string) {
    if (source !== 'similar') return;
    const iframe = document.getElementById('fashion-hint-iframe-similar');
    iframe?.remove();
}